import React,{Component} from 'react'
import {Row,Col} from 'react-bootstrap'
import SectionControl from './SectionControl'
import {OnUpdate} from '../../components/Shared/ActionControl'

export class Detail extends Component{

    constructor (props){
        super(props)
        this.state = { id:0, noteText:"", sectionId:1, message:"", current:null}
        this.entity='note'
    }

    componentDidUpdate(){
        if(this.state.id!==this.props.id) {
            //console.log(`NoteDetail.componentDidUpdate editing ${this.props.editing}`)
            this.Load()
        }
    }

    onChange = (e) => {
        if(e?.target)
        //  console.log("onChange", e, this.state.current)
        this.setState({noteText: e.target.value})    
    }

    onSection = (e) => {
        if(this.props.editing) {
            this.setState({sectionId: e.target?.value ?? 1, message:'Section updated !'})
        }
    }
    
    Load() {        
        if(this.props.id>0) {            
            this.props.global.GetItem(this.entity, this.props.id)
            .then(data => this.setState({id:data.Id, noteText:data.Text, sectionId:data.SectionId, current:data}))
            .catch(error => {
                this.props.onMessage(error.message)
            })
        }
    }    
    
    Delete(id) {
        if(this.props.editing) {
            this.props.global.DELETE(this.entity, id)
            .then(()=> {
                this.props.LoadNotes()
                this.setState({id:0, noteText:''})
            })
            .catch(error => {
                this.props.onMessage(error.message)
            })
        }
    }

    Cancel() {
        if(this.props.editing) {
            this.props.LoadNotes()
            this.Load()
        }
    }

    Update(id) {
        if(id>0) {
            fetch(`${this.props.global.apiUrl+this.entity}`,{
                method:'PUT',
                headers:this.props.global.headers,
                body:JSON.stringify({
                Id: id,
                SectionId: this.state.sectionId,
                Text:this.state.noteText
                })
            })
            .then(()=> {
                this.props.LoadNotes()
                this.Load()
            })
            .catch(error => console.log({ error }))
        }
    }

    render() {

        return (
this.state.id>0 ? 
<Col className="lg" style={this.props.onStyle(this.state.sectionId,0,0.9)} >
<SectionControl name='SectionId' global={this.props.global} id={this.state.sectionId} onChange={this.onSection} readOnly={!this.props.editing} label={this.props.id} /> 

<Row>
    <textarea className={this.props.editing?"Editing":"Viewing"} rows="2"
        value={this.state.noteText} onChange={this.onChange} readOnly={!this.props.editing} />
</Row>

{ this.props.editing ?
    <OnUpdate onUpdate={()=> this.Update(this.props.id)} onCancel={()=>this.Cancel()} onDelete={()=>this.Delete(this.props.id)} />
: 
    <OnUpdate onEdit={()=> this.props.onNote(this.props.id, true)} />
}

    </Col>
: <h3>Note Detail ...</h3> 


        )
    }
}
